// extracted by mini-css-extract-plugin
export default {"container":"TextInput_container__+5UgM","fullWidth":"TextInput_fullWidth__mMIZe"};